var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof eysenseHeader !== "undefined") return resolve();
	__webpack_require__.l("https://previewqa.eysense.ey.com/fabric-eysense-header/remoteEntry.js?v=2518c82d93ed6c851df91bf4fce3f5d465bf1560", (event) => {
		if(typeof eysenseHeader !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "eysenseHeader");
}).then(() => (eysenseHeader));